import { render, staticRenderFns } from "./ProfilesSetup.vue?vue&type=template&id=942cee5a&scoped=true&"
import script from "./ProfilesSetup.vue?vue&type=script&lang=js&"
export * from "./ProfilesSetup.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesSetup.vue?vue&type=style&index=0&id=942cee5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942cee5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('942cee5a')) {
      api.createRecord('942cee5a', component.options)
    } else {
      api.reload('942cee5a', component.options)
    }
    module.hot.accept("./ProfilesSetup.vue?vue&type=template&id=942cee5a&scoped=true&", function () {
      api.rerender('942cee5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ProfilesSetup.vue"
export default component.exports